import { useRef, useState, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from '@mui/material';
import { themeColors } from 'src/theme';

export const TruncatedTextWithTooltip = ({ text }: { text: string }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip
      title={isTruncated ? text : ''}
      disableHoverListener={!isTruncated}
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: themeColors.grayMedium,
            color: themeColors.black,
            p: 1.25,
            fontFamily: 'Poppins',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '130%',
          },
        },
      }}
    >
      <Typography
        ref={textRef}
        noWrap
        variant="h4"
        component="span"
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 'calc(100% - 40px)', display: 'block', whiteSpace: 'nowrap' }}
      >
        {text}
      </Typography>
    </Tooltip>
  );
};
